import AIChatbot from "@/components/AIChatbot";
import { PageTransition } from "@/components/PageTransition";

const TeclyAI = () => (
  <PageTransition>
    <AIChatbot />
  </PageTransition>
);

export default TeclyAI;
